import React, { useCallback, useEffect, useState } from 'react';
import { lazy } from 'react';
import mockComponents from './componentData/mockComponents';
import mockComponentsData from './componentData/mockComponentsData';
import CreateAction from '../../components/operational/createAction';
import themeSlice from '../../redux/themeSlice';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import store from '../../redux/store';
import { staticComponentValueConverter } from './DnDNew/components/DnDItems/DnDComponents/StaticComponentValues';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { mergeObjects } from '../../helper/Converters';
import { license } from '../../data/license';
import { defaultGeneralStyleValues } from '../../data/defaultThemeData';
const staticValuesArray = Array.from({ length: 300 }, (_, index) => index);

const emptyPage = {
  id: 'emptyPage',
  name: 'emptyPage',
  type: 'dnd',
  sections: [
    {
      id: 'emptyPage',
      name: 'emptyPage',
      themeData: [],
    },
  ],
  isReservedName: true,
  isSectionsIncrementable: false,
};
const Main = lazy(() => import('./Main.jsx'));

function ThemeScreen() {
  const [data, setData] = useState(null);
  const [COLLECTIONS, setCOLLECTIONS] = useState(null);
  const [options, setOptions] = useState(null);
  const params = useParams();

  const themeId = params?.id;

  const windowWidth = useSelector(state => state.eventListenerSlice?.windowSize)?.width;
  const dispatch = useDispatch();
  ThemeScreenRequests({ setData, setCOLLECTIONS, setOptions, themeId })
  useEffect(() => {
    const staticValues = staticComponentValueConverter(staticValuesArray);
    const staticValuesArrayFromObject = Object.values(staticValues);
    dispatch(themeSlice.actions.setStaticValues(staticValuesArrayFromObject));
  }, [windowWidth]);

  return <>{data && <Main data={data} COLLECTIONS={COLLECTIONS} options={options}></Main>}</>;
}

export default ThemeScreen;

export const ThemeScreenRequests = ({ setData, setCOLLECTIONS, setOptions, themeId }) => {


  const currentLicense = useSelector(state => state.myUserSlice?.license);



  const navigate = useNavigate();
  const dispatch = useDispatch();
  const merchantId = store.getState()?.myUserSlice?.merchantId;


  const createImageUrl = (imageId, fileName) => {
    return imageId ? `https://cdn.myikas.com/images/${merchantId}/${imageId}/image_540.webp` : null;
  };
  const getAllCategories = async type => {
    const categories = (await getCollection('category', 'listCategory')) || {};
  };
  const getAllBranding = async type => {
    const brands = (await getCollection('brand', 'listProductBrand')) || {};
  };
  const getCollection = useCallback(async (type, url, id, page = 1, skip) => {
    const response = await CreateAction({
      method: 'post',
      path: `/${url}`,
      data: { id, page },
      headers: {
        'Content-Type': 'application/json',
      },
      showPreLoader: false,
      isFileUploading: false,
      hideToastMessages: true
    });

    if (response?.error) return navigate('/dashboard/theme');

    const collectionData = response?.result?.resultData?.data;
    if (!collectionData) return navigate('/dashboard/theme');

    const newRowCount = response?.result?.resultData?.count;
    const limit = response?.result?.resultData?.limit;
    const collections = {};
    collectionData?.forEach(element => {
      if (element?.id && element?.name) {
        const collection = {
          value: element?.id,
          label: element?.name,
          image: '',
          type,
          parentId: element?.parentId,
          data: { ...element, type },
        };
        if (collection && element?.id && element?.name) collections[element.id] = collection;
      }
    });

    const filteredCollections = Object.values(collections).filter(brand => brand);
    const hashMap = {};
    filteredCollections.forEach(item => {
      hashMap[item.value] = { image: null, text: item?.name, id: item.value };
    });
    dispatch(themeSlice.actions.setImageHashMap(hashMap));
    if (type === 'brand') dispatch(themeSlice.actions.setBrands(collections));
    if (type === 'category') dispatch(themeSlice.actions.setCategories(collections));
    if (newRowCount / limit > page && !skip) {
      const maxNum = Math.ceil(newRowCount / limit);
      for (let i = 1; i < maxNum; i++) {
        getCollection(type, url, id, i + 1, true);
      }
    } else if (type === 'category' && page * limit >= newRowCount) {
      dispatch(themeSlice.actions.setCategoriesWithParentId(collections));
    }
  }, []);

  const getSingleProduct = async requestData => {
    const response = await CreateAction({
      method: 'post',
      path: `/findSingleProduct`,
      data: {
        page: 1,
        id: requestData?.productId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });
    if (response?.error) return;

    const productData = response?.result?.resultData?.[0];
    const variants = productData?.variants;
    const allVariantIds = requestData?.variantIds && Object.keys(requestData?.variantIds);
    const products = {};
    const hashMap = {};
    allVariantIds?.forEach(variantId => {
      const selectedVariant = variants?.find(variant => variant?.id === variantId);
      if (!selectedVariant) return;
      const images = selectedVariant?.images;

      const firstImage = images?.[0];
      const id = requestData?.productId + ';' + variantId;
      const firstImageUrl = createImageUrl(firstImage?.id, firstImage?.fileName);
      if (id && productData?.name) {
        const product = {
          value: id,
          label: productData?.name,
          image: firstImageUrl,
          data: { ...selectedVariant, id, type: 'product', variants: [selectedVariant, ...variants?.filter(variant => variant?.id !== variantId)] },
          type: 'product',
        };
        hashMap[id] = { image: firstImageUrl, text: productData?.name, id };
        if (typeof product === 'object') products[id] = product;
      }
    });
    dispatch(themeSlice.actions.setProducts(products));
    dispatch(themeSlice.actions.setImageHashMap(hashMap));
  };

  const getAllProducts = async () => {
    const data = (await getProducts()) || [];
    dispatch(themeSlice.actions.setProducts(data.products));
    dispatch(themeSlice.actions.setImageHashMap(data?.hashMap));
  };

  const getProducts = async () => {
    const response = await CreateAction({
      method: 'post',
      path: `/productGroup`,
      data: {
        page: 1,
      },
      headers: {
        'Content-Type': 'application/json',
      },
      showPreLoader: true,
      isFileUploading: false,

      hideToastMessages: true,
    });

    if (response?.error) navigate('/dashboard/theme/');

    const productsData = response?.result?.resultData;
    if (!productsData) navigate('/dashboard/theme/');
    const rowCount = response?.result?.resultData?.count;
    const products = {};
    const hashMap = {};
    productsData?.forEach(element => {
      const variant = element?.variants?.[0];
      const images = variant?.images;

      const firstImage = images?.[0];
      const id = element.id + ';' + variant?.id;
      const firstImageUrl = createImageUrl(firstImage?.id, firstImage?.fileName);
      if (id && element?.name) {
        const product = {
          value: id,
          label: element?.name,
          image: firstImageUrl,
          data: { ...element, id, type: 'product' },
          type: 'product',
        };
        hashMap[id] = { image: firstImageUrl, text: element?.name, id };
        products[id] = product;
      }
    });

    // const paginatedProducts = newRowCount > skip ? await getProducts(skip + 100) : []
    // const allProducts = [...products, ...paginatedProducts]
    return { products, rowCount, hashMap };
  };

  const getIconTypes = async () => {
    try {
      const response = await CreateAction({
        method: 'get',
        path: `/icons/getTypes`,
        showPreLoader: false,
        isFileUploading: false,

        hideToastMessages: true,
        data: {
          themeId: themeId,
        },
      });

      if (response?.error) navigate('/dashboard/theme/');

      response?.result?.resultData?.sort();
      dispatch(themeSlice.actions.setIconsTypes(response?.result?.resultData));
    } catch { }
  };

  const getIcons = async () => {
    try {
      const response = await CreateAction({
        method: 'get',
        path: `/icons`,
        showPreLoader: false,
        isFileUploading: false,

        hideToastMessages: true,
        data: {
          themeId: themeId,
        },
      });

      if (response?.error) navigate('/dashboard/theme/');

      dispatch(themeSlice.actions.setIcons(response?.result?.resultData));
    } catch { }
  };

  const checkItemState = item => {
    if (!item) return;

    const itemType = item?.type;
    const itemName = item?.name;

    if (!itemType || !itemName) return item;
    const currentComponentType = mockComponentsData[itemType];
    if (!currentComponentType || !currentComponentType.variants) return item;
    const currentComponent = currentComponentType.variants.find(collectionItem => collectionItem?.name === itemName);
    if (!currentComponent) return item;
    let currentCustomization = item?.customization;
    let currentData = item?.data;
    const id = item?.id || uuid();
    const themeDataCustomizationKeys = item?.customization && Object.keys(item?.customization);
    const currentComponentCustomizationKeys =
      currentComponent?.customization && Object.keys(currentComponent?.customization);
    if (themeDataCustomizationKeys?.join('') !== currentComponentCustomizationKeys?.join('')) {
      currentCustomization = mergeObjects(currentComponent?.customization, item?.customization, itemName);
    }
    const themeDataDataKeys = item?.data && Object.keys(item?.data);
    const currentComponentDataKeys = currentComponent?.data && Object.keys(currentComponent?.data);
    if (themeDataDataKeys?.join('') !== currentComponentDataKeys?.join('')) {
      currentData = mergeObjects(currentComponent?.data, item?.data, itemName);
    }

    return { ...item, id, customization: currentCustomization, data: currentData };
  };

  const getThemeData = async () => {
    const editingThemeId = themeId;
    try {
      const response = await CreateAction({
        method: 'get',
        path: `/themeData/${editingThemeId}`,
        showPreLoader: false,
        isFileUploading: false,

        hideToastMessages: true,
      });
      if (response?.error) navigate('/dashboard/theme/');
      const draftData = response?.result?.resultData?.draftData;
      const options = response?.result?.resultData?.settings;
      const isDraftData = draftData && Object.keys(draftData) && Object.keys(draftData)?.length !== 0;
      const themeData = isDraftData ? draftData : response?.result?.resultData?.data;

      const pageObject = themeData?.pages;
      if (!pageObject) return;
      if (pageObject) {
        const requestObject = {};
        const categoryRequestArray = [];
        const brandRequestArray = [];
        const pages = Object.values(pageObject);
        const defaultPages = mockComponents?.defaultPages;
        const COLLECTIONComponents = mockComponentsData;
        Object.keys(defaultPages).forEach(key => {
          const currentPage = pages.find(page => page.id === key);
          const isPageEmpty = currentPage?.sections?.length === 1 && currentPage?.sections?.[0]?.themeData?.length === 0 && defaultPages[key].type !== "dnd"
          if (!currentPage || isPageEmpty) {
            const value = defaultPages[key];
            const pageComponents = value.components;
            const themeData = pageComponents
              ?.map(pageComponent => {
                const type = pageComponent.type;
                const id = pageComponent.id;
                const componentType = COLLECTIONComponents[type];
                const component = componentType?.variants?.find(variant => variant.id === id);
                if (component) {
                  return {
                    ...structuredClone(component),
                    id: uuid(),
                  };
                }
              })
              ?.filter(item => item);
            const newPage = {
              ...structuredClone(emptyPage),
              sections: [
                {
                  id: key,
                  name: key,
                  themeData: themeData || [],
                },
              ],
              id: key,
              name: value.name || key,
              isSectionsIncrementable: value.isSectionsIncrementable || false,
              type: value.type,
              customPageType: value.customPageType
            };
            if (isPageEmpty) {
              const emptyPageIndex = pages.findIndex(page => page.id === key)
              pages[emptyPageIndex] = newPage
            } else {
              pages.push(newPage);
            }
            return;
          }


          currentPage.type = defaultPages[key].type;
          currentPage.isReservedName = !defaultPages[key].customPageType
          currentPage.customPageType = defaultPages[key].customPageType
        });

        pages?.forEach((page, pageIndex) => {
          const sections = page?.sections;
          sections?.forEach((section, sectionIndex) => {
            const sectionThemeData = section?.themeData;
            sectionThemeData?.forEach((component, componentIndex) => {
              pages[pageIndex].sections[sectionIndex].themeData[componentIndex] = checkItemState(component);
              const images = component?.data?.images;
              images?.forEach(image => {
                const type = image?.pointTo?.pointToType;
                const pointTo = image?.pointTo?.pointTo;
                const idArray = pointTo?.split(';');
                if (type === 'product') {
                  if (requestObject[pointTo]) {
                    requestObject[pointTo].variantIds[idArray?.[1]] = '';
                  } else {
                    requestObject[pointTo] = {
                      productId: idArray?.[0],
                      variantIds: { [idArray?.[1]]: '' },
                    };
                  }
                }
                if (type === 'category') {
                  categoryRequestArray.push(idArray?.[0]);
                }
                if (type === 'brand') {
                  brandRequestArray.push(idArray?.[0]);
                }
              });
            });
          });

          if (!page?.isReservedName && !page?.customPageType) {
            page.customPageType = "Main"
          }
        });
        const requestArray = Object.values(requestObject)?.filter(data => data);
        requestArray.forEach(requestData => {
          if (requestData?.productId) {
            getSingleProduct(requestData);
          }
        });
        themeData.pages = pages;
        // categoryRequestArray?.filter(data => data).forEach((requestData) => {
        //   getCollection("category", "listCategory", requestData)
        // })
        // brandRequestArray?.filter(data => data).forEach((requestData) => {
        //   getCollection("brand", "listProductBrand", requestData)
        // })
      }

      const branding = themeData?.branding
      const generalStyle = branding?.generalStyle
      if (generalStyle) {
        Object.keys(generalStyle)?.forEach((newStyle) => {
          const isColor = defaultGeneralStyleValues[newStyle]
          if (!isColor) return

          const value = generalStyle[newStyle]
          const root = document.documentElement;
          root.style.setProperty(`--${newStyle}`, value);

        })
      }
      setData(themeData);
      const stringifiedThemeData = JSON.stringify(themeData);
      stringifiedThemeData && dispatch(themeSlice.actions.setStringifiedOnLoadThemeData(stringifiedThemeData));
      dispatch(themeSlice.actions.setBranding(themeData?.branding));
      dispatch(themeSlice.actions.setSettings(options));
      dispatch(themeSlice.actions.setThemeLicense(options?.isDemo ? license.DEMO : currentLicense))
      return response?.result?.resultData;
    } catch { }
  };

  const getData = async () => {
    const themeData = await getThemeData();

    const COLLECTIONComponents = mockComponentsData;

    const pages = mockComponents?.pages;
    const collection = {};
    const collectionOptions = {};

    COLLECTIONComponents &&
      Object.keys(COLLECTIONComponents).forEach(componentName => {
        collectionOptions[componentName] = COLLECTIONComponents[componentName]?.options;
      });

    pages &&
      Object.keys(pages).forEach(pageName => {
        const currentCollectionNames = (pages && pages[pageName]) || [];
        const singlePageCollection =
          COLLECTIONComponents &&
          currentCollectionNames.map(componentName => {
            const currentComponentCollection = COLLECTIONComponents[componentName];
            const currentComponentCollectionTypes = currentComponentCollection?.variants;
            return currentComponentCollectionTypes;
          });
        collection[pageName] = singlePageCollection.flat(2);
      });

    setCOLLECTIONS(collection);
    setOptions(collectionOptions);

    return themeData;
  };

  const getProductAttributes = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/getCustomAttributes`,
      showPreLoader: false,
      isFileUploading: false,

      hideToastMessages: true,
    });
    if (response?.error) return

    const newAttributes = response?.result?.resultData
    dispatch(themeSlice.actions.setAttributes(newAttributes))

  }
  const getStockLocations = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/getStockLocations`,
      showPreLoader: false,
      isFileUploading: false,

      hideToastMessages: true,
    });
    if (response?.error) return

    const newStockLocations = response?.result?.resultData
    dispatch(themeSlice.actions.setStockLocations(newStockLocations))

  }

  const getAllThemeData = async () => {
    await dispatch(themeSlice.actions.setThemeId(themeId));
    if (!themeId) navigate('/dashboard/theme/');
    const themeData = await getData();
    if (!themeData) navigate('/dashboard/theme/');
    const themeSettings = themeData?.settings;

    getIcons();
    getIconTypes();
    if (!themeSettings?.isWebView) {
      getAllProducts();
      getAllBranding();
      getAllCategories();
    }
    dispatch(themeSlice.actions.resetDeletedItems());
    await getProductAttributes()
    await getStockLocations()

  };
  useEffect(() => {
    if (themeId) {
      getAllThemeData();
    }
  }, [themeId]);

}

/** @license ThemeScreen @2024
 * Copyright Berk Emre Uzun and his affiliates.
 *
 * LICENSE file in the src/pages/ThemeScreen directory of this source tree.
 */
